(function() {
    'use strict';

    angular
        .module('sideApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('docente', {
            parent: 'app',
            url: '/docente?page&sort&search',
            data: {
            	authorities: ['PROFESOR'],
                pageTitle: 'Mis Asignaturas - Evaluación Docente'
            },
            views: {
                'content@': {
                    templateUrl: 'app/docente/clasesdocente.html',
                    controller: 'DocenteController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null,
                anio: '0',
                modelo: '0',
                nivel: '0',
                centro: '0',
                indice: '0',
                ic: false,
                iic: '0'
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        anio: $stateParams.anio,
                        modelo: $stateParams.modelo,
                        nivel: $stateParams.nivel,
                        centro: $stateParams.centro,
                        indice: $stateParams.indice,
                        ic: $stateParams.ic,
                        iic: $stateParams.iic
                    };
                }]
            }
        })
        .state('autoevaluacion', {
            parent: 'docente',
            url: '/autoevaluacion/{ambito}/{profesor}/{modelo}/{nivel}/{idins}/{tipoauto}',
            data: {
            	authorities: ['PROFESOR'],
                pageTitle: 'Autoevaluación - Evaluación Docente'
            },
            views: {
                'content@': {
                    templateUrl: 'app/docente/autoevaluacion.html',
                    controller: 'AutoevaluacionController',
                    controllerAs: 'vm'
                }
            },
            params: {
            	ambito: '$stateParams.ambito',
            	profesor: '$stateParams.profesor',
            	modelo: '$stateParams.modelo',
            	nivel: '$stateParams.nivel',
            	idins: '$stateParams.idins',
				tipoauto: '$stateParams.tipoauto'
            }
        })
        .state('reporteprofesor', {
            parent: 'app',
            url: '/misevaluaciones?page&sort&search&type',
            data: {
            	authorities: ['PROFESOR'],
                pageTitle: 'Mis Reportes Evaluativos'
            },
            views: {
                'content@': {
                    templateUrl: 'app/docente/misreportesevaluativos.html',
                    controller: 'MisReportesEvaluativosController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null,
                type: '1',
                indice : '1',
                ic: false,
                iic: '0',
                anio: '0',
                aniostr: '',
                modelo: '0',
                nivel: '0',
                centro: '0',
                ep: false
                
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        type: $stateParams.type,
                        indice: $stateParams.indice,
                        ic: $stateParams.ic,
                        iic: $stateParams.iic,
                        anio: $stateParams.anio,
                        aniostr: $stateParams.aniostr,
                        modelo: $stateParams.modelo,
                        nivel: $stateParams.nivel,
                        centro: $stateParams.centro,
                        ep: $stateParams.ep
                    };
                }]
            }
        })
         .state('verReporteOO', {
            parent: 'reporteprofesor',
            url: '/reporteoo/{id}',
            data: {
            	authorities: ['PROFESOR'],
                pageTitle: 'Reporte Evaluativo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reportes/reporteevaluativoOO/reporteevaluativoOO.html',
                    controller: 'ReporteEvaluativoOOController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'MiReporteEvaluativoOO','$state', function($stateParams, MiReporteEvaluativoOO,$state) {
              	  return MiReporteEvaluativoOO.get({id: $stateParams.id}).$promise;
                }]
            },
        })
		.state('verReporteLic', {
		    parent: 'reporteprofesor',
		    url: '/reportelic/{id}',
		    data: {
		    	authorities: ['PROFESOR'],
		        pageTitle: 'Reporte Evaluativo'
		    },
		    views: {
		        'content@': {
		            templateUrl: 'app/reportes/reporteevaluativoLic/reporteevaluativoLic.html',
		            controller: 'ReporteEvaluativoLicController',
		            controllerAs: 'vm'
		        }
		    },
		    resolve: {
		        entity: ['$stateParams', 'ReporteEvaluativoLicService','$state', function($stateParams, ReporteEvaluativoLicService,$state) {
		      	  return ReporteEvaluativoLicService.ver({id: $stateParams.id}).$promise;
		        }]
		    },
		})
        .state('verReporteCU', {
            parent: 'reporteprofesor',
            url: '/reportecu/{id}',
            data: {
            	authorities: ['PROFESOR'],
                pageTitle: 'Reporte Evaluativo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reportes/reporteevaluativoCU/reporteevaluativoCU.html',
                    controller: 'ReporteEvaluativoCUController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'ReporteEvaluativoCUService','$state', function($stateParams, ReporteEvaluativoCUService,$state) {
              	  return ReporteEvaluativoCUService.ver({id: $stateParams.id}).$promise;
                }]
            },
        })
        .state('verReporteLI', {
            parent: 'reporteprofesor',
            url: '/reporteli/{id}',
            data: {
            	authorities: ['PROFESOR'],
                pageTitle: 'Reporte Evaluativo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reportes/reporteevaluativoLI/reporteevaluativoLI.html',
                    controller: 'ReporteEvaluativoLIController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'MiReporteEvaluativoLibre','$state', function($stateParams, MiReporteEvaluativoLibre,$state) {
              	  return MiReporteEvaluativoLibre.get({id: $stateParams.id}).$promise;
                }]
            },

        })
        .state('verReporteRegular', {
            parent: 'reporteprofesor',
            url: '/reporteregular/{id}',
            data: {
            	authorities: ['PROFESOR'],
                pageTitle: 'Reporte Evaluativo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reportes/reporteevaluativoRegular/reporteevaluativoRegular.html',
                    controller: 'ReporteEvaluativoRegularController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'ReporteEvaluativoRegularService','$state', function($stateParams, ReporteEvaluativoRegularService,$state) {
              	  return ReporteEvaluativoRegularService.ver({id: $stateParams.id}).$promise;
                }]
            },
        })
        .state('verReporteVirtual', {
            parent: 'reporteprofesor',
            url: '/reportevirtual/{id}',
            data: {
            	authorities: ['PROFESOR'],
                pageTitle: 'Reporte Evaluativo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reportes/reporteevaluativoVirtual/reporteevaluativoVirtual.html',
                    controller: 'ReporteEvaluativoVirtualController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'ReporteEvaluativoVirtualService','$state', function($stateParams, ReporteEvaluativoVirtualService,$state) {
              	  return ReporteEvaluativoVirtualService.ver({id: $stateParams.id}).$promise;
                }]
            },
        })
        .state('verReporteUAEV', {
            parent: 'reporteprofesor',
            url: '/reporteuaev/{id}',
            data: {
            	authorities: ['PROFESOR'],
                pageTitle: 'Reporte Evaluativo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reportes/reporteevaluativoUAEV/reporteevaluativoUAEV.html',
                    controller: 'ReporteEvaluativoUAEVController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'ReporteEvaluativoUAEVService','$state', function($stateParams, ReporteEvaluativoUAEVService,$state) {
              	  return ReporteEvaluativoUAEVService.ver({id: $stateParams.id}).$promise;
                }]
            },
        })
		.state('verReporteBachillerato', {
			parent: 'reporteprofesor',
			url: '/reporteBachillerato/{id}',
			data: {
				authorities: ['PROFESOR'],
				pageTitle: 'Reporte Evaluativo'
			},
			views: {
				'content@': {
					templateUrl: 'app/reportes/reporteevaluativoBachillerato/reporteevaluativoBachillerato.html',
					controller: 'ReporteEvaluativoBachilleratoController',
					controllerAs: 'vm'
				}
			},
			resolve: {
				entity: ['$stateParams', 'ReporteEvaluativoBachilleratoService', '$state', function($stateParams, ReporteEvaluativoBachilleratoService, $state) {
					return ReporteEvaluativoBachilleratoService.ver({ id: $stateParams.id }).$promise;
				}]
			},
		})
		.state('verreporteMixtoPII', {
			parent: 'reporteprofesor',
			url: '/reporteMixtoPII/{id}',
			data: {
				authorities: ['PROFESOR'],
				pageTitle: 'Reporte Evaluativo'
			},
			views: {
				'content@': {
					templateUrl: 'app/reportes/reporteevaluativoMixtoPII/reporteevaluativoMixtoPII.html',
					controller: 'ReporteEvaluativoMixtoPIIController',
					controllerAs: 'vm'
				}
			},
			resolve: {
				entity: ['$stateParams', 'ReporteEvaluativoMixtoPIIService', '$state', function($stateParams, ReporteEvaluativoMixtoPIIService, $state) {
					return ReporteEvaluativoMixtoPIIService.ver({ id: $stateParams.id }).$promise;
				}]
			},
		})
        .state('verreporteVirtualPII', {
            parent: 'reporteprofesor',
            url: '/reporteVirtualPII/{id}',
            data: {
                authorities: ['PROFESOR'],
                pageTitle: 'Reporte Evaluativo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reportes/reporteevaluativoVirtualPII/reporteevaluativoVirtualPII.html',
                    controller: 'ReporteEvaluativoVirtualPIIController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'ReporteEvaluativoVirtualPIIService', '$state', function($stateParams, ReporteEvaluativoVirtualPIIService, $state) {
                    return ReporteEvaluativoVirtualPIIService.ver({ id: $stateParams.id }).$promise;
                }]
            },
        })
    }

})();
